import { extractApiErrorDetails } from '@/lib/apiErrorDetails';

const TECHNICAL_ERROR = /(?:^|\s)(?:HTTP|ERR-|[A-Z][A-Z0-9_]{2,}|TypeError|ReferenceError|SyntaxError|Server error|Error:|Failed to fetch|NetworkError|Network request failed|Load failed)/;

/**
 * Unica traduzione UI per gli errori operativi CRM: conserva un messaggio già
 * comprensibile, ma non rende visibili codici, stack o dettagli di trasporto.
 * Gli inattesi sono già registrati dal boundary server-side/app_incident.
 */
export function operationalUiErrorMessage(error: unknown, fallback: string): string {
  const raw = error instanceof Error ? error.message : typeof error === 'string' ? error : '';
  const details = extractApiErrorDetails(raw);
  const message = details.message
    .replace(/\s*ERR-[A-Z0-9-]+\.?/gi, '')
    .replace(/\s+/g, ' ')
    .trim();
  if (!message || message.length > 360 || TECHNICAL_ERROR.test(message)) return fallback;
  return message;
}
